export const HR_ARTICLES = '/hr/Articles'
export const HR_ARTICLES_UNREAD_COUNT = `${HR_ARTICLES}/unread-count`
export const HR_ARTICLE_CATEGORIES = '/hr/ArticleCategories'

export function articleById(id: number) {
  return `${HR_ARTICLES}/${id}`
}

export function articleContent(id: number) {
  return `${HR_ARTICLES}/${id}/content`
}

export function articleAttachments(id: number) {
  return `${HR_ARTICLES}/${id}/attachments`
}

export function articlePublish(id: number) {
  return `${HR_ARTICLES}/${id}/publish`
}

export function articleRead(id: number) {
  return `${HR_ARTICLES}/${id}/read`
}

export function articleReads(id: number) {
  return `${HR_ARTICLES}/${id}/reads`
}

export function articleRelated(id: number) {
  return `${HR_ARTICLES}/${id}/related`
}
